var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex w-full rounded overflow-hidden gap-3",
      class: _vm.parentClass,
      style: { "--radio-color": _vm.color },
      attrs: { id: "checkBoxes_container" },
    },
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "div",
        {
          key: option.value,
          staticClass: "radio-container flex items-center gap-2",
        },
        [
          _c("input", {
            staticClass: "inp-cbx customRadio",
            attrs: { name: _vm.name, type: _vm.type, id: option.value },
            domProps: {
              value: option.value,
              checked: _vm.value == option.value,
            },
            on: { change: _vm.handleChange },
          }),
          _c(
            "label",
            { class: _vm.getLabelClasses, attrs: { for: option.value } },
            [
              _c("span", { class: _vm.getSpanClasses }, [
                _vm.isCheckBox
                  ? _c("svg", { attrs: { width: "12px", height: "10px" } }, [
                      _c("use", {
                        attrs: { "xlink:href": _vm.getreference(index, true) },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _c("span", [_vm._v(_vm._s(option.label))]),
            ]
          ),
          _c("svg", { staticClass: "inline-svg" }, [
            _c(
              "symbol",
              { attrs: { id: _vm.getreference(index), viewbox: "0 0 12 10" } },
              [_c("polyline", { attrs: { points: "1.5 6 4.5 9 10.5 1" } })]
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }